import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertZoneEntry = createAsyncThunk(
	"insertZoneEntry",
	async (postData) => {
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=insertZones`,
				postData
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const updateZone = createAsyncThunk("updateZone", async (postData) => {
	try {
		const response = await axios.post(
			`${baseUrl}?apicall=updateZone`,
			postData
		);
		return response.data;
	} catch (error) {
		throw error;
	}
});

export const insertStudenEntry = createAsyncThunk(
	"insertStudenEntry",
	async ({ postData }, thunkAPI) => {
		//console.log("postdata=>",postData);
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=insertStudentEntry`,
				//JSON.stringify(postData),
				postData,
				{
					headers: {
						// "Content-Type": "multipart/form-data"
						"Content-Type": "application/json",
					},
				}
			);
			//  console.log("response data=>",response.data);

			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const updateSchool = createAsyncThunk(
	"updateSchool",
	async (postData) => {
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=updateSchools`,
				postData
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const insertSubUser = createAsyncThunk(
	"insertSubUser",
	async (postData) => {
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=insertUserPageAssign`,
				postData
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const updateSubUser = createAsyncThunk(
	"updateSubUser",
	async (postData) => {
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=updateUserMasterEdit`,
				postData
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const updateItemEntry = createAsyncThunk(
	"updateItemEntry",
	async (postData) => {
		try {
			const response = await axios.post(
				`${baseUrl}?apicall=updateItem`,
				postData
			);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const fetchZoneData = createAsyncThunk("fetchZoneData", async (id) => {
	try {
		let endpoint = id ? `getZonesdata&zoneId=${id}` : `getZonesdata`;
		const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);

		return response.data;
	} catch (error) {
		throw error;
	}
});

export const fetchStudentData = createAsyncThunk(
	"fetchStudentData",
	async ({ id, userId } = {}) => {
		try {
			// let endpoint = id ? `getStudentData&studId=${id}` : 'getStudentData';
			// let endpoint = `getStudentData`;
			let endpoint = `getWStudentData`; //nikhil sir api
			if (id) {
				endpoint += `&studId=${id}`;
			} else if (userId) {
				endpoint += `&userId=${userId}`;
			} else {
				endpoint = `getStudentData`;
			}
			const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
);

export const fetchSubUser = createAsyncThunk("fetchSubUser", async (id) => {
	try {
		let endpoint = id ? `getUserPageReg&suId=${id}` : "getUserPageReg";
		// if (userId) {
		//     endpoint = 'getUserPageReg&userId=${userId}';
		// }
		const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
		return response.data;
	} catch (error) {
		throw error;
	}
});

export const fetchUserPages = createAsyncThunk("fetchUserPages", async () => {
	try {
		let endpoint = "getUserPages";
		const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
		return response.data;
	} catch (error) {
		throw error;
	}
});

export const deleteZone = createAsyncThunk("deleteZone", async (id) => {
	try {
		const response = await axios.delete(
			`${baseUrl}?apicall=deleteZone&zoneId=${id}`
		);
		return response.data;
	} catch (error) {
		throw error;
	}
});

export const deleteSubUser = createAsyncThunk("deleteSubUser", async (id) => {
	try {
		const response = await axios.delete(
			`${baseUrl}?apicall=deleteSubuser&suId=${id}`
		);
		return response.data;
	} catch (error) {
		throw error;
	}
});

export const deleteStudents = createAsyncThunk("deleteStudents", async (id) => {
	try {
		const response = await axios.delete(
			`${baseUrl}?apicall=deleteStudent&studId=${id}`
		);
		return response.data;
	} catch (error) {
		throw error;
	}
});

const zoneSlice = createSlice({
	name: "ZoneData",
	initialState: {
		isLoading: false,
		zones: null,
		studs: null,
		subUser: null,
		pages: null,
		delzone: null,
		delsubur: null,
		delstud: null,
		isError: false,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchZoneData.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(fetchZoneData.fulfilled, (state, action) => {
			state.isLoading = false;
			state.zones = action.payload;
		});
		builder.addCase(fetchZoneData.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(fetchStudentData.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(fetchStudentData.fulfilled, (state, action) => {
			state.isLoading = false;
			state.studs = action.payload;
		});
		builder.addCase(fetchStudentData.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(fetchSubUser.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(fetchSubUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.subUser = action.payload;
		});
		builder.addCase(fetchSubUser.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(fetchUserPages.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(fetchUserPages.fulfilled, (state, action) => {
			state.isLoading = false;
			state.pages = action.payload;
		});
		builder.addCase(fetchUserPages.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(deleteZone.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(deleteZone.fulfilled, (state, action) => {
			state.isLoading = false;
			state.delzone = action.payload;
		});
		builder.addCase(deleteZone.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(deleteSubUser.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(deleteSubUser.fulfilled, (state, action) => {
			state.isLoading = false;
			state.delsubur = action.payload;
		});
		builder.addCase(deleteSubUser.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});

		builder.addCase(deleteStudents.pending, (state, action) => {
			state.isLoading = true;
		});
		builder.addCase(deleteStudents.fulfilled, (state, action) => {
			state.isLoading = false;
			state.delstud = action.payload;
		});
		builder.addCase(deleteStudents.rejected, (state, action) => {
			console.log("Error", action.error.message);
			state.isError = true;
		});
	},
});

export default zoneSlice.reducer;
